import React from "react";
import styles from "./styles.css";
import Modal from "../../shared/modal";
import VideoGallerySlider from "../video-gallery-slider";
import PropTypes from "prop-types";
import { PAGE_SOURCE } from "../../../constants/app-constants";

const VideoGallerySliderModal = ({
    videoUrl,
    source,
    showModal,
    onClose,
    chapters,
    initialChapterIndex,
    calculatorRef,
    scrollToSection,
    isFetchingOrderDetails,
    isKbbShown,
    handleKbbModal,
    ctaProps,
    step,
    gaId,
    email
}) => {

    const outerModalStyle = source === PAGE_SOURCE.CDP ? "styles.cdpOuterModal" : "styles.outerModal";
    return (
        <Modal isOpen={true} overlayClass="videoGallerySlider">
            <div styleName={outerModalStyle}>
                <VideoGallerySlider
                    videoUrl={videoUrl}
                    chapters={chapters}
                    footer={
                        <></>
                    }
                    source={source}
                    showModal={showModal}
                    onClose={onClose}
                    initialChapterIndex={initialChapterIndex}
                    calculatorRef={calculatorRef}
                    scrollToSection={scrollToSection}
                    isFetchingOrderDetails={isFetchingOrderDetails}
                    isKbbShown={isKbbShown}
                    handleKbbModal={handleKbbModal}
                    ctaProps={ctaProps}
                    step={step}
                    gaId={gaId}
                    email={email}
                />
            </div>
        </Modal>
    );
};

VideoGallerySliderModal.propTypes = {
    content: PropTypes.object,
    videoUrl: PropTypes.string,
    chapters: PropTypes.array,
    footer: PropTypes.node,
    source: PropTypes.string,
    showModal: PropTypes.bool,
    onClose: PropTypes.func,
    onWishlistClick: PropTypes.func,
    isWishlisted: PropTypes.bool,
    initialChapterIndex: PropTypes.number,
    calculatorRef: PropTypes.object,
    scrollToSection: PropTypes.func,
    isFetchingOrderDetails: PropTypes.bool,
    isKbbShown: PropTypes.bool,
    handleKbbModal: PropTypes.func,
    ctaProps: PropTypes.object,
    step: PropTypes.object,
    gaId: PropTypes.string,
    email: PropTypes.string
};

export default VideoGallerySliderModal;
